import { Image } from '@/atoms/Image'
import { Text } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'

export function ClaimTicketSection() {
  const { t } = useTranslate('pif')

  return (
    <section className="relative w-full bg-[#f9b74b] px-4 pb-[6rem] pt-10 md:flex md:items-center md:px-12 md:py-[7.5rem] lg:px-[4rem] lg:py-[10rem]">
      <div className="mx-auto w-full max-w-[1440px] lg:flex lg:items-center lg:gap-10 xl:gap-[4rem]">
        <div
          style={{ aspectRatio: 1 }}
          className="relative mx-auto min-w-[370px] max-w-[370px] grow-1 md:max-h-[672px] md:max-w-[672px] xl:max-h-[692px] xl:max-w-[692px]"
        >
          <Image
            alt=""
            src="/v1760542713/theatrical/david/nitzevet-zeruiah-isolated-characters2"
            fill
            className="object-cover"
          />
        </div>

        <div className="mt-10 flex w-full flex-col items-start gap-8 self-stretch px-0 lg:mt-0 lg:flex-[1_0_0] lg:justify-center lg:gap-10 lg:pr-0">
          <div className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-3 not-italic text-[#411e09]">
            <p className="font-angel-royal relative w-full text-5xl lowercase not-italic leading-[2.5rem] text-[#411e09] md:text-[4rem] md:leading-[3rem]">
              {t('davidNeedHelpTitle', 'Need Help getting Tickets?')}
            </p>
            <Text weight="medium" className="photon-paragraph-lg md:photon-paragraph-xl !text-[#411E09]">
              {t(
                'davidNeedHelpDescription',
                "Thanks to generous supporters, you can claim a free ticket to see DAVID in theaters. If cost is holding you back, we've got you covered - this story is for everyone.",
              )}
            </Text>
          </div>

          <DavidButton
            variant="dark"
            href={`${paths.getBaseURL()}/tickets/david?promo=claim-free-ticket`}
            className="w-fit min-w-0 md:w-auto md:min-w-[200px]"
          >
            {t('claimFreeTickets', 'Claim Free Tickets')}
          </DavidButton>
        </div>
      </div>
    </section>
  )
}
